import {combineReducers} from 'redux';

import create from './org-create/reducer';
import index from './orgs-index/reducer';
import instance from './org-instance/reducer';

export default combineReducers({index, create, instance});
